import { ChangeEvent } from 'react'
import { withStyles, WithStyles, TextField, Theme, createStyles } from '@material-ui/core'


const styles = (theme: Theme) =>
    createStyles({
        codeInput: {
            margin: theme.spacing(1),
            maxWidth: '80px',

        },
        codeInputWrapper: {
            textAlign: 'center',
        }
    });

interface CodeNumberInputProperties {
    value: string,
    onChange: (newValue: string) => void
}

const CodeNumberInput: React.FC<CodeNumberInputProperties & WithStyles<typeof styles>> = (properties) => {
    const { classes, value, onChange } = properties

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value?.toUpperCase();

        if (newValue.length <= 4) {
            onChange(newValue)
        }
    }

    return (
        <div className={classes.codeInputWrapper}>
            <TextField
                autoComplete='off'
                autoCorrect='off'
                autoCapitalize='characters'
                className={classes.codeInput}
                type='text'
                value={value}
                variant='outlined'
                size='small'
                placeholder='XXXX'
                onChange={handleChange}
            />
        </div>
    )
}

export default withStyles(styles, { withTheme: true })(CodeNumberInput)
